// Sessão do participante: token opaco de 12 h, guardado como hash e revogável no servidor.
// localStorage mantém a sessão no F5, ao fechar e reabrir a aba e ao abrir o QR fixo
// em outra aba. A validade vem do servidor e o /me é conferido a cada carregamento.
const TOKEN_KEY = 'attendeeToken';
const EXPIRES_KEY = 'attendeeTokenExpiresAt';
const SESSION_END_CODES = new Set(['session_invalid', 'session_expired', 'session_required']);

export const ATTENDEE_SESSION_ENDED = 'pontonow:attendee-session-ended';

const storage = (name) => {
  try {
    return window[name] || null;
  } catch {
    return null;
  }
};

const parseUtcMs = (value) => {
  if (!value) return null;
  const ms = Date.parse(`${String(value).trim().replace(' ', 'T')}Z`);
  return Number.isNaN(ms) ? null : ms;
};

export function clearAttendeeSession() {
  storage('localStorage')?.removeItem(TOKEN_KEY);
  storage('localStorage')?.removeItem(EXPIRES_KEY);
  storage('sessionStorage')?.removeItem(TOKEN_KEY);
}

export function saveAttendeeSession(token, expiresAt) {
  const local = storage('localStorage');
  if (!local || !token) return;
  local.setItem(TOKEN_KEY, token);
  if (parseUtcMs(expiresAt) != null) local.setItem(EXPIRES_KEY, String(expiresAt));
  else local.removeItem(EXPIRES_KEY);
  storage('sessionStorage')?.removeItem(TOKEN_KEY);
}

export function readAttendeeSession(nowMs = Date.now()) {
  const local = storage('localStorage');
  if (!local) return null;
  const legacy = storage('sessionStorage')?.getItem(TOKEN_KEY);
  if (legacy && !local.getItem(TOKEN_KEY)) saveAttendeeSession(legacy, null);
  const token = local.getItem(TOKEN_KEY);
  if (!token) return null;
  const expiresAt = local.getItem(EXPIRES_KEY);
  const expiresMs = parseUtcMs(expiresAt);
  if (expiresMs != null && expiresMs <= nowMs) {
    clearAttendeeSession();
    return null;
  }
  return { token, expiresAt: expiresAt || null };
}

export function shouldEndAttendeeSession({ status, code, requestToken, currentToken }) {
  if (status !== 401 || !SESSION_END_CODES.has(code)) return false;
  return Boolean(requestToken) && requestToken === currentToken;
}
